import { render, staticRenderFns } from "./ManageGiftCertificate.vue?vue&type=template&id=79e6214a"
import script from "./ManageGiftCertificate.vue?vue&type=script&lang=ts"
export * from "./ManageGiftCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports